import UrlHelpers from "./url";

export class i18n {
    private _storageKey = 'centerLocalization';

    constructor() {
    }

    private _getFromLocalStorage = (): any => {
        let strLocalization = (<any>window).localStorage.getItem(this._storageKey);
        if (strLocalization !== undefined && strLocalization !== null && strLocalization !== '') {
            let retval: any = null;
            try {
                retval = JSON.parse(strLocalization);
                return retval
            } catch (exp) {
                console.error("Cannot get localization from locall storage: ", exp)
            }
        } else {
            console.error("Cannot get localized strings from localStorage, because localisation not found!");
        }
        return null;
    };
    private _refreshLocalStorage = () => {
        window.localStorage.removeItem(this._storageKey);
        let url = UrlHelpers.getSrcFromScript('translation');
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.setRequestHeader('accept', 'application/json');
        xhr.setRequestHeader('Cache-Control', 'no-cache');
        xhr.onload = () => {
            console.log("result: ", xhr.responseText);
            let result = JSON.parse(xhr.responseText);
            window.localStorage.setItem(this._storageKey, JSON.stringify(result));
        };
        xhr.send();
    };
    private _refreshLocalStorageForLanguage = (languageKey: i18n.Language) => {
        if (!i18n.Language.includes(languageKey.toString())) {
            console.error('languageKey is not of type LanguageKeys');
            return;
        }
        const storageKey = this.getStorageKeyForLanguageKey(languageKey);
        window.localStorage.removeItem(storageKey);
        let url = UrlHelpers.getSrcFromScript('translation');
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.setRequestHeader('accept', 'application/json');
        xhr.setRequestHeader('Cache-Control', 'no-cache');
        xhr.setRequestHeader('Accept-Language', languageKey.toString())
        xhr.onload = () => {
            console.log("result: ", xhr.responseText);
            let result = JSON.parse(xhr.responseText);
            window.localStorage.setItem(storageKey, JSON.stringify(result));
        };
        xhr.send();
    };
    public getTranslation = (key: string, targetLanguage?: i18n.Language): string => {
        let storageKey = this._storageKey;
        let refresh = this._refreshLocalStorage;
        if (targetLanguage && i18n.Language.includes(targetLanguage.toString())) {
            storageKey = this.getStorageKeyForLanguageKey(targetLanguage);
            refresh = () => {
                this._refreshLocalStorageForLanguage(targetLanguage)
            };
        }
        let translations = JSON.parse(window.localStorage.getItem(storageKey));
        if (translations) {
            let result: any = translations[key];
            if (result) {
                return result.other;
            }
        }
        refresh();
        translations = JSON.parse(window.localStorage.getItem(storageKey));
        let result = translations[key];
        if (result) {
            return result.other;
        }
        console.warn('translation "' + key + '" not found');
        return key;
    };

    public static replaceTranslationPlaceholder = (v: string, ph: string, replacement: string): string => {
        if (v.isNullOrEmpty()) {
            console.warn("String is null or empty. Nothing was replaced");
            return v;
        } else if (ph.isNullOrEmpty()) {
            console.warn("No placeholder found. Nothing can be replaced");
            return v;
        }
        let retVal = v.replace(ph, replacement);
        return retVal;
    }

    public getStorageKeyForLanguageKey(lk: i18n.Language): string {
        return i18n.Language.includes(lk.toString()) ? `${this._storageKey}_${lk.toString()}` : this._storageKey;
    }
}

export namespace i18n {
    export enum Language {
        Default = "en",
        DE = "de",
        EN = "en"
    }

    export namespace Language {
        export function includes(value: string): boolean {
            return (<any>Object).values(Language).includes(value);
        }

        export function parse(value: string): Language {
            value = value.toLowerCase();
            return Language.includes(value) ? <Language>value : Language.Default;
        }
    }
}


